import { Validator, NG_VALIDATORS, UntypedFormControl } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
  selector: '[datexCommonValidEmailValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: ValidEmailValidatorDirective, multi: true }
  ],
  standalone: false
})
export class ValidEmailValidatorDirective implements Validator {

  validate(c: UntypedFormControl) {

    const value: string = c.value;
    const isValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
    if (isValid) {
      return null;
    } else {
      return { name: true };
    }
  }
}

